import { ChangeDetectorRef, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { LoyaltyParamsService } from 'app/services/loyalty/params.service';
import { MessageService } from 'primeng/primeng';
import { Observable } from 'rxjs';

import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { AuthService } from 'app/services/user/auth.service';
import { Campaign3BreadcrumbComponent } from '../campaign-3/components/campaign-3-breadcrumb/campaign-3-breadcrumb.component';

import { ActivatedRoute, Router } from '@angular/router';
import { LoyaltyAcmService } from 'app/services/loyalty/loyalty-acm.service';
import { Group } from 'ng2-dragula';
import { BreadCrumbModel } from '../campaign-3/models/campaign-3-breadcrumb.model';
import { ActionType } from '../campaign-3/models/campaign-3-info-base.model';
import { GenerazioneDropdown } from '../campaign-3/models/campaign-3-planning.model';
import { AreaGeo, Insegna } from '../campaign-3/models/campaign-3-touchpoint.model';
import { PhaseToolbarModel } from '../campaign-3/models/phases-toolbar.model';
import { Campaign3Service } from '../campaign-3/services/campaign3.service';


import { CalculateFruitionDateRequest, Campaign3ActionStatus, Campaign3Info, Campaign3MessageInstanceRules, Campaign3StatusMapping, JsonSchema, MessageInstanceObject, MessageInstanceObjectTypes, MessageInstanceRuleTypes, Touchpoint } from '../campaign-3/models/campaign-3.model';
import { Message3ActionTypeComponent } from './message-3-action-type/message-3-action-type.component';
import { Message3CustomerTargetComponent } from './message-3-customer-target/message-3-customer-target.component';
import { Message3EmissionConditionsComponent } from './message-3-emission-conditions/message-3-emission-conditions.component';
import { Message3InfoBaseComponent } from './message-3-info-base/message-3-info-base.component';
import { Message3PlanningComponent } from './message-3-planning/message-3-planning.component';
import { Message3ProductsTargetComponent } from './message-3-products-target/message-3-products-target.component';
import { Message3TouchpointComponent } from './message-3-touchpoint/message-3-touchpoint.component';
import { Message3ValidationsComponent } from './message-3-validations/message-3-validations.component';


@Component({
  selector: 'app-campaign-3-message',
  templateUrl: './campaign-3-message.html',
  styleUrls: ['./campaign-3-message.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class Campaign3MessageComponent implements OnInit {

  //COMPONENTE BREADCRUMB
  @ViewChild('breadcrumbComponent') breadcrumbComponent: Campaign3BreadcrumbComponent;

  //COMPONENTI DELLE VARIE FASI:
  @ViewChild('infoBaseComponent') infoBaseComponent: Message3InfoBaseComponent; //FASE 1
  @ViewChild('planningComponent') planningComponent:  Message3PlanningComponent; //FASE 2
  @ViewChild('actionTypeComponent') actionTypeComponent: Message3ActionTypeComponent; //FASE 3
  @ViewChild('emissionConditionsComponent') emissionConditionsComponent:  Message3EmissionConditionsComponent; //FASE 4
/*   @ViewChild('fruitionConditionsComponent') fruitionConditionsComponent: Campaign3FruitionConditionsComponent; //FASE 5 */
  @ViewChild('customerTargetComponent') customerTargetComponent: Message3CustomerTargetComponent; //FASE 6
  @ViewChild('productsTargetComponent') productsTargetComponent: Message3ProductsTargetComponent; //FASE 7
  @ViewChild('touchpointComponent') touchpointComponent: Message3TouchpointComponent; //FASE 8
  @ViewChild('validationsComponent') validationsComponent: Message3ValidationsComponent //FASE 9

  actionTypeCode = ""; //"C" coupon, "M" messaggio

  language: string = "it";
  dateFormat: string = "dd/MM/yyyy";
  schemaMode: string = this.srvCampaign3.schema_modes.CREATE;
  uiModes = {infoBase: this.srvCampaign3.ui_modes.CREATE,planning: this.srvCampaign3.ui_modes.CREATE,actionTypes:this.srvCampaign3.ui_modes.CREATE,emissionConditions:this.srvCampaign3.ui_modes.CREATE,fruitionConditions:this.srvCampaign3.ui_modes.CREATE,customerTarget:this.srvCampaign3.ui_modes.CREATE,productsTarget:this.srvCampaign3.ui_modes.CREATE,touchpoint:this.srvCampaign3.ui_modes.CREATE,validations:this.srvCampaign3.ui_modes.CREATE};

  messageInstanceFromServer: any;

  campaignTypeName: string = "";
  campaignTypeDescription: string = "";
  realodDataValidation: boolean = false;
  getProductOnlyBarcodeReady:boolean = false;


  readOnly: boolean = false;

  combos = {
    infobase: {
      couponTypes: null,
      allCouponTypes: null,
      advantageTypes: null,
      //new
      messageTypes:null,
      allMessageTypes:null
    },
    planning: {
      modalitaInizioFruizione: null,
      modalitaFineFruizione: null
    },
    emissionConditions: {
      articoli: null
    }
  }

  gestioneNuovaTouchpoint: boolean = true;


  //decide quale delle fasi caricare messaggio o coupon
  statusPhaseArgument:string= "MSG";
  statusMapping: Campaign3StatusMapping = new Campaign3StatusMapping(this.statusPhaseArgument);

  actionTypesList: Array<ActionType> = [];
  // productList: Array<ProductItemComplete> = [];
  accumulatorListEmission: Array<any> = [];
  accumulatorListFruition: Array<any> = [];
  miRuleTypesList: Array<MessageInstanceRuleTypes> = [];
  miObjectTypesList: Array<MessageInstanceObjectTypes> = [];
  distributionListEmission: Array<any> = [];
/*   distributionListFruition: Array<any> = []; */
  campaign3MessageInstanceRules: Campaign3MessageInstanceRules;
  paniereListEmission: Array<any> = [];
    listProductsEmission: Array<any> = [];

/*   paniereListFruition: Array<any> = []; */
  departmentListEmission: Array<any> = [];
/*   departmentListFruition: Array<any> = []; */
  categoriesListEmission: Array<any> = [];
/*   categoriesListFruition: Array<any> = []; */
  storeList: Array<any> = [];
  areeList: Array<AreaGeo> = [];
  groupList: Array<Group> = [];
  insegneList: Array<Insegna> = [];
  touchpointList: Array<any> = [];
  /*
  comboGiornoSettimanaInizioFruizione: Array<{value: number,name: string}>
  comboGiornoSettimanaFineFruizione: Array<{value: number,name: string}>
  */
  statusList: Array<Campaign3ActionStatus> = [];

  touchpointListEmission: Array<Touchpoint> = [];
/*   touchpointListFruition: Array<Touchpoint> = []; */

  touchpointLoaded: boolean = false;
  coupon_mode: string = this.srvCampaign3.coupon_modes.CREATE;

  campaignPhases: Array<PhaseToolbarModel> = [];

  //currentJsonSchemaMode = null;
  currentPhaseIndex: number = 0;

  globalFormsSchema: JsonSchema;
  phaseChanged: boolean = false;
  breadcrumbs: Array<BreadCrumbModel> = [];

  messageInstanceObject: MessageInstanceObject = null;

  campaignInfo: Campaign3Info;
  messageInstanceId: number | null = null;

  idCampaign: number;

  errorRetriveData: boolean = false;

  show = {globalFormsSchema: false,breadcrumbs: false,phases: false,infoBase: false,planning: false,actionType: false,emissionConditions: false,fruitionConditions: false,customerTarget: false,productsTarget: false,touchpoint: false,validations: false,touchpointComponent: false}

  enable = {confirmButton: false}

  translations: any;

    //salvare tra i preferiti

    showSuccessPopup: boolean = false;
    favouriteAction: boolean = false;
    showSuccessDeletePopup: boolean = false;

    favouriteMessageInstance:Array<MessageInstanceObject> =[];
    minIdToAllowSaving: number;
    allowSaveActionTemplate: boolean;
  constructor(
    public srvCampaign3: Campaign3Service,
    private srvTranslate: TranslateService,
    private srvMessage: MessageService,
    private srvParam: LoyaltyParamsService,
    private activatedRoute: ActivatedRoute,
    private srvLoyaltyAcm: LoyaltyAcmService,
    private authService: AuthService,
    private srvCalendar: CalendarTranslateService,
    private paramsLoyService: LoyaltyParamsService,
    private router: Router,
    private cdRef: ChangeDetectorRef
  ) {
    this.messageInstanceId = this.activatedRoute.snapshot.params['messageInstanceId'] > 0 ? this.activatedRoute.snapshot.params['messageInstanceId'] : null;
    this.idCampaign = this.activatedRoute.snapshot.params['campaignId'];
  }

  ngAfterViewChecked()
  {
    this.cdRef.detectChanges();
  }
  reloadTouchPoints(){

    if(+this.messageInstanceObject.id>0){
      const LISTA_TOUCHPOINT_EMISSIONE = this.srvCampaign3.getTouchPointListForCouponing_new("E",this.actionTypeCode,this.messageInstanceObject.id);
      const LISTA_TOUCHPOINT_FRUIZIONE = this.srvCampaign3.getTouchPointListForCouponing_new("F",this.actionTypeCode,this.messageInstanceObject.id);
      var self = this;
      Observable.zip(
        LISTA_TOUCHPOINT_EMISSIONE,
        LISTA_TOUCHPOINT_FRUIZIONE
        ).subscribe(([
          res_tp_e,
          res_tp_f
        ]) => {

          if(res_tp_e && res_tp_e.length>0){
            self.touchpointListEmission=res_tp_e;
          }

         /*  if(res_tp_f && res_tp_f.length>0){
            self.touchpointListFruition=res_tp_f;
          } */

          if(self.touchpointComponent){
            self.touchpointComponent.reloadInfoTouchpoint();
          }

          if(self.validationsComponent && this.srvCampaign3.getStatusNumberFromCode(this.messageInstanceObject.status,this.statusMapping)>=this.statusMapping.validations.number){
            /*       self.validationsComponent.touchpointListEmissionForWizard = res_tp_e;
                  self.validationsComponent.touchpointListFruitionForWizard = res_tp_f; */
                  self.validationsComponent.certificationInfo.loaded = false;
                  self.validationsComponent.reloadData();
                  self.validationsComponent.checkWizardList();
                }

        });


    }
  }
  messageInstanceObjectChange(messageInstanceObject: MessageInstanceObject){
    if (this.uiModes.infoBase == this.srvCampaign3.ui_modes.EDIT) {
      this.messageInstanceObject = messageInstanceObject;
      var self = this;
      //KS-6825 se pubblicata domina il JsonForm
      // messageInstanceObject.status == this.statusMapping.pubblicata.code
      
      if (
        messageInstanceObject.status == this.statusMapping.pubblicazioneAnnullata.code ||
        messageInstanceObject.status == this.statusMapping.pubblicazioneInInvio.code ||
        messageInstanceObject.status == this.statusMapping.richiestaPubblicazione.code ||
        messageInstanceObject.status == this.statusMapping.inGenerazione.code 
       
  
      ) {
        
        this.readOnly = true;
        this.onFormSchemaChanged(this.globalFormsSchema)
      }
      else{
        this.readOnly= false;
      }


    if(this.uiModes.infoBase == this.srvCampaign3.ui_modes.EDIT){
      this.messageInstanceObject = messageInstanceObject;
      var self = this;
      setTimeout(function(){

        //Dopo il primo salvataggio, non si può più cambiare il tipo di coupon
        if(self.infoBaseComponent){
          if(self.srvCampaign3.getStatusNumberFromCode(self.messageInstanceObject.status,self.statusMapping)!=1){
            self.infoBaseComponent.message_type.disabled = true;
          }
          else{
            self.planningComponent.data_inizio_emissione.disabled = self.globalFormsSchema.properties.pianificazione.form[self.srvCampaign3.pianificazioneFieldsName.data_inizio_emissione].disabled;
          }

       //   self.infoBaseComponent.messageInstanceObject = Object.assign({},self.messageInstanceObject);
        }

        //se la data di fruizione è variabile allora in fase 3 non si può scegliere "STATICO" come coupon
        if(self.actionTypeComponent && self.planningComponent){

          var self2 = self;

          setTimeout(function(){


            /*** CONDIZIONI SU PIANIFICAZIONE ***/
            //Se statico, data_inizio_emissione e data_fine_emissione non modificabili dopo la pubblicazione
            if(self2.messageInstanceObject.flgCouponingMethod == self.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.shortCode && self2.messageInstanceObject.status == self2.statusMapping.pubblicata.code){
              if(self2.planningComponent && self2.planningComponent.data_inizio_emissione)
                self2.planningComponent.data_inizio_emissione.disabled = true;
              if(self2.planningComponent && self2.planningComponent.data_fine_emissione)
                self2.planningComponent.data_fine_emissione.disabled = true;
            }
            else{
              if(self2.planningComponent && self2.planningComponent.data_inizio_emissione && this.readOnly==true){
                self2.planningComponent.data_inizio_emissione.disabled = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.data_inizio_emissione].disabled;
              }
              if(self2.planningComponent && self2.planningComponent.data_fine_emissione && this.readOnly==true){
                self2.planningComponent.data_fine_emissione.disabled = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.data_fine_emissione].disabled;
              }
            }

            //se la promo non ha flg_rolling = "1" allora data_inizio_fruizione e data_fine_fruizione sono obbligatori
            if(self2.messageInstanceObject.flgRolling){
              if(self2.messageInstanceObject.flgRolling!="1"){
            /*     if(self2.planningComponent.data_inizio_fruizione)
                  self2.planningComponent.data_inizio_fruizione.required = true;
                if(self2.planningComponent.data_fine_fruizione)
                self2.planningComponent.data_fine_fruizione.required = true; */
              }
              else{
                //se flg_rolling = 1 allora non ci sono data_inizio_fruizione e data_fine_fruizione, però metto lo stesso questo controllo per il futuro...
            /*     if(self2.planningComponent.data_inizio_fruizione)
                  self2.planningComponent.data_inizio_fruizione.required = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.data_inizio_fruizione].required;
                if(self2.planningComponent.data_fine_fruizione)
                  self2.planningComponent.data_fine_fruizione.required = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.data_fine_fruizione].required; */
              }
            }

            //se la promo è variabile, allora le modalità di inizio fruizione e di fine fruizione sono obbligatorie
            if(self2.messageInstanceObject.flgRolling == "1"){
            /*   if(self2.planningComponent.modalita_inizio_fruizione) self2.planningComponent.modalita_inizio_fruizione.required = true;
              if(self2.planningComponent.modalita_fine_fruizione) self2.planningComponent.modalita_fine_fruizione.required = true;
 */
              //metto tutti i campi a required che tanto vengono visualizzati in ngIf, perciò se ci sono allora sono obbligatori.
              if(self2.planningComponent.giorno_settimana_inizio) self2.planningComponent.giorno_settimana_inizio.required = true;
              if(self2.planningComponent.giorno_settimana_fine) self2.planningComponent.giorno_settimana_fine.required = true;
             /*  if(self2.planningComponent.data_inizio_fruizione_fissa) self2.planningComponent.data_inizio_fruizione_fissa.required = true;
              if(self2.planningComponent.data_fine_fruizione_fissa) self2.planningComponent.data_fine_fruizione_fissa.required = true;
              if(self2.planningComponent.offset_inizio_fruizione) self2.planningComponent.offset_inizio_fruizione.required = true;
              if(self2.planningComponent.offset_fine_fruizione) self2.planningComponent.offset_fine_fruizione.required = true; */
            }
            else{
             /*  if(self2.planningComponent.modalita_inizio_fruizione) self2.planningComponent.modalita_inizio_fruizione.required = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.modalita_inizio_fruizione].required;
              if(self2.planningComponent.modalita_fine_fruizione) self2.planningComponent.modalita_fine_fruizione.required = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.modalita_fine_fruizione].required; */
              if(self2.planningComponent.giorno_settimana_inizio) self2.planningComponent.giorno_settimana_inizio.required = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.giorno_settimana_inizio].required;
              if(self2.planningComponent.giorno_settimana_fine) self2.planningComponent.giorno_settimana_fine.required = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.giorno_settimana_fine].required;
/*               if(self2.planningComponent.data_inizio_fruizione_fissa) self2.planningComponent.data_inizio_fruizione_fissa.required = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.data_inizio_fruizione_fissa].required;
              if(self2.planningComponent.data_fine_fruizione_fissa) self2.planningComponent.data_fine_fruizione_fissa.required = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.data_fine_fruizione_fissa].required;
              if(self2.planningComponent.offset_inizio_fruizione) self2.planningComponent.offset_inizio_fruizione.required = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.offset_inizio_fruizione].required;
              if(self2.planningComponent.offset_fine_fruizione) self2.planningComponent.offset_fine_fruizione.required = self2.globalFormsSchema.properties.pianificazione.form[self2.srvCampaign3.pianificazioneFieldsName.offset_fine_fruizione].required; */
            }

            self2.planningComponent.messageInstanceObject = Object.assign({},self2.messageInstanceObject);

          },100);
        }


        if(self.emissionConditionsComponent){
            //Se la promo è statica la soglia di emissione (e quindi il tipo soglia di emissione) non va dichiarata
            if(self.messageInstanceObject.flgCouponingMethod == self.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.shortCode){

              if(self.emissionConditionsComponent.sogliaEmissione && self.emissionConditionsComponent.tipoSogliaEmissione){
                self.emissionConditionsComponent.sogliaEmissione.required = false;
                self.emissionConditionsComponent.sogliaEmissione.fieldModel = null;
                self.emissionConditionsComponent.sogliaEmissione.disabled = true;
                self.emissionConditionsComponent.fieldModel.sogliaEmissione = null;


                self.emissionConditionsComponent.tipoSogliaEmissione.required = false;
                // self.emissionConditionsComponent.tipoSogliaEmissione.fieldModel = null;
                self.emissionConditionsComponent.tipoSogliaEmissione.disabled = true;
                //self.emissionConditionsComponent.fieldModel.tipoSogliaEmissione = null;

                let cvRuleIndex = self.messageInstanceObject.messageInstanceRule.findIndex(x => x.id == self.miRuleTypesList.find(x => x.code == "CV").id && x.ruleScope == self.srvCampaign3.ruleScopesEmissionFruition.EMISSION);
                let cvRule = self.messageInstanceObject.messageInstanceRule[cvRuleIndex];

                if(cvRule){
                  let mirTipoSogliaIndex =cvRule.messageInstanceRuleDetail.findIndex(x=>x.id == self.miObjectTypesList.find(x=>x.code == "PTRT").id);
                  if(mirTipoSogliaIndex!=-1)
                    cvRule.messageInstanceRuleDetail.splice(mirTipoSogliaIndex,1);

                  let mirSogliaIndex = cvRule.messageInstanceRuleDetail.findIndex(x=>x.id == self.miRuleTypesList.find(x=>x.code == "PTRE").id);
                  if(mirSogliaIndex!=-1)
                    cvRule.messageInstanceRuleDetail.splice(mirSogliaIndex,1);

                  if(cvRule.messageInstanceRuleDetail.length==0){
                    self.messageInstanceObject.messageInstanceRule.splice(cvRuleIndex,1);
                  }
                }
              }
            }
            else{

              if(self.emissionConditionsComponent.sogliaEmissione && self.emissionConditionsComponent.tipoSogliaEmissione){

                self.emissionConditionsComponent.sogliaEmissione.required = self.emissionConditionsComponent.formSchema.form.soglia_emissione_coupon.required;
                //self.emissionConditionsComponent.sogliaEmissione.fieldModel = null;
                self.emissionConditionsComponent.sogliaEmissione.disabled = self.emissionConditionsComponent.formSchema.form.soglia_emissione_coupon.disabled;
                //self.emissionConditionsComponent.fieldModel.sogliaEmissione = null;

                self.emissionConditionsComponent.tipoSogliaEmissione.required = self.emissionConditionsComponent.formSchema.form.tipo_soglia_emissione.required;
                //self.emissionConditionsComponent.tipoSogliaEmissione.fieldModel = null;
                self.emissionConditionsComponent.tipoSogliaEmissione.disabled = self.emissionConditionsComponent.formSchema.form.tipo_soglia_emissione.disabled;
                //self.emissionConditionsComponent.fieldModel.tipoSogliaEmissione = null;

                let cvRuleIndex = self.messageInstanceObject.messageInstanceRule.findIndex(x => x.id == self.miRuleTypesList.find(x => x.code == "CV").id && x.ruleScope == self.srvCampaign3.ruleScopesEmissionFruition.EMISSION);

                let cvRule = self.messageInstanceObject.messageInstanceRule[cvRuleIndex];

                if(cvRule){
                  let mirTipoSogliaIndex =cvRule.messageInstanceRuleDetail.findIndex(x=>x.id == self.miObjectTypesList.find(x=>x.code == "PTRT").id);
                  if(mirTipoSogliaIndex!=-1)
                    cvRule.messageInstanceRuleDetail.splice(mirTipoSogliaIndex,1);

                  let mirSogliaIndex = cvRule.messageInstanceRuleDetail.findIndex(x=>x.id == self.miRuleTypesList.find(x=>x.code == "PTRE").id);
                  if(mirSogliaIndex!=-1)
                    cvRule.messageInstanceRuleDetail.splice(mirSogliaIndex,1);

                  if(cvRule.messageInstanceRuleDetail.length==0){
                    self.messageInstanceObject.messageInstanceRule.splice(cvRuleIndex,1);
                  }
                }
              }
            }

            //Se la promo è statica allora non può avere il barcode attivatore
            if(self.messageInstanceObject.flgCouponingMethod == self.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.shortCode){
              if(self.emissionConditionsComponent.switchBarcodeAttivatoreComponent){
                let baRuleIndex = self.messageInstanceObject.messageInstanceRule.findIndex(x => x.id == self.miRuleTypesList.find(x => x.code == "BA").id);
                if(baRuleIndex>-1){
                  self.messageInstanceObject.messageInstanceRule.splice(baRuleIndex,1);
                }
                self.emissionConditionsComponent.BA_rules = [];
                self.emissionConditionsComponent.resetEmissioneBarcodeAttivatore();
                self.emissionConditionsComponent.switch.soloBarcodeAttivatore = false;
                self.emissionConditionsComponent.switchBarcodeAttivatoreComponent.disabled = false;
                self.emissionConditionsComponent.switchBarcodeAttivatoreComponent.visible = false;
              }
            }
            else{
              self.emissionConditionsComponent.switchBarcodeAttivatoreComponent.disabled = self.readOnly;
              self.emissionConditionsComponent.switchBarcodeAttivatoreComponent.visible = true;
            }

            //da KS-5420, se il coupon è statico, allora cancello e inibisco regole di coupon ripetibile in emissione (cioè mir CV con rulescope emission e con mird PRTR e PMCN)
            if(self.messageInstanceObject.flgCouponingMethod == self.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.shortCode){

              self.emissionConditionsComponent.switch.couponRipetibile = false;
              self.emissionConditionsComponent.disabledSwitch.couponRipetibile = true;
              let indexCV = self.messageInstanceObject.messageInstanceRule.findIndex(x=>(x.ruleTypeId == self.miRuleTypesList.find(x=>x.code == "CV").id && x.ruleScope == self.srvCampaign3.ruleScopesEmissionFruition.EMISSION));
              let indexLM = self.messageInstanceObject.messageInstanceRule.findIndex(x=>(x.ruleTypeId == self.miRuleTypesList.find(x=>x.code == "LM").id && x.ruleScope == self.srvCampaign3.ruleScopesEmissionFruition.EMISSION));

              if(indexCV>-1){

                let indexPRTR = self.messageInstanceObject.messageInstanceRule[indexCV].messageInstanceRuleDetail.findIndex(x=>x.objectTypeId ==  self.miObjectTypesList.find(x=>x.code == "PRTR").id);
                if(indexPRTR>-1){
                  self.messageInstanceObject.messageInstanceRule[indexCV].messageInstanceRuleDetail.splice(indexPRTR,1);
                }

                /*** CAMBIAMENTO A SEGUITO DI CALL 02/04/2024 (vedi commenti issue KS-5417 e KS-5418) ***/
                /*
                let indexPMCN = self.messageInstanceObject.messageInstanceRule[indexCV].messageInstanceRuleDetail.findIndex(x=>x.objectTypeId ==  self.miObjectTypesList.find(x=>x.code == "PMCN").id);
                if(indexPMCN>-1){
                  self.messageInstanceObject.messageInstanceRule[indexCV].messageInstanceRuleDetail.splice(indexPMCN,1);
                }
                */
              }

              if(indexLM>-1){
                let indexPMCT = self.messageInstanceObject.messageInstanceRule[indexLM].messageInstanceRuleDetail.findIndex(x=>x.objectTypeId ==  self.miObjectTypesList.find(x=>x.code == "PMCT").id);
                if(indexPMCT>-1){
                  self.messageInstanceObject.messageInstanceRule[indexLM].messageInstanceRuleDetail.splice(indexPMCT,1);
                }
              }
            }
            else if(self.messageInstanceObject.flgCouponingMethod == self.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.shortCode){
              self.emissionConditionsComponent.disabledSwitch.couponRipetibile = false;
            }

            //Se la promo ha coupon ripetibile in emissione, è obbligatorio soglia riemissione
            //COMMENTATO PERCHE' CAMBIATO NUOVAMENTE DA JSON FORM OBBLIGATORIO
            /*
            if(self.messageInstanceObject.flgCouponingMethod == self.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.shortCode ){

                self.emissionConditionsComponent.switch.couponRipetibile = true;
                var self2 = self;
                setTimeout(function(){
                  if(self2.emissionConditionsComponent.sogliaRiemissione){
                    self2.emissionConditionsComponent.sogliaRiemissione.required = true;
                    self2.emissionConditionsComponent.sogliaRiemissione.fieldModel = null;
                    self2.emissionConditionsComponent.fieldModel.sogliaEmissione = null;
                  }
                },100);
            }
            */

            //da KS-5420, se il tipo azione è NOLOY o ALL allora cancello e inibisco regole di emissione gestione accumulatori
            if(self.messageInstanceObject.targetLoyaltyClass == self.srvCampaign3.clientiDestinatiPromo.NOLOY || self.messageInstanceObject.targetLoyaltyClass == self.srvCampaign3.clientiDestinatiPromo.ALL ){
              self.emissionConditionsComponent.switch.gestioneAccumulatori = false;
              self.emissionConditionsComponent.disabledSwitch.gestioneAccumulatori = true;
              let indexAC = self.messageInstanceObject.messageInstanceRule.findIndex(x=>(x.ruleTypeId == self.miRuleTypesList.find(x=>x.code == "AC").id && x.ruleScope == self.srvCampaign3.ruleScopesEmissionFruition.EMISSION));
              if(indexAC>-1) self.messageInstanceObject.messageInstanceRule.splice(indexAC,1);
            }
            else if(self.messageInstanceObject.targetLoyaltyClass == self.srvCampaign3.clientiDestinatiPromo.LOY){
              self.emissionConditionsComponent.disabledSwitch.gestioneAccumulatori = self.readOnly;
            }

            self.emissionConditionsComponent.messageInstanceObject = Object.assign({},self.messageInstanceObject);

          }

     /*      if(self.fruitionConditionsComponent){

            //da KS-5420, se il tipo azione è NOLOY o ALL allora cancello e inibisco regole di emissione gestione accumulatori
            if(self.messageInstanceObject.targetLoyaltyClass == self.srvCampaign3.clientiDestinatiPromo.NOLOY  || self.messageInstanceObject.targetLoyaltyClass == self.srvCampaign3.clientiDestinatiPromo.ALL ){
              self.fruitionConditionsComponent.switch.gestioneAccumulatori = false;
              self.fruitionConditionsComponent.disabledSwitch.gestioneAccumulatori = true;

              let indexAC = self.messageInstanceObject.messageInstanceRule.findIndex(x=>(x.ruleTypeId == self.miRuleTypesList.find(x=>x.code == "AC").id && x.ruleScope == self.srvCampaign3.ruleScopesEmissionFruition.FRUITION));
              if(indexAC>-1) self.messageInstanceObject.messageInstanceRule.splice(indexAC,1);
            }
            else if(self.messageInstanceObject.targetLoyaltyClass == self.srvCampaign3.clientiDestinatiPromo.LOY){
              //self.fruitionConditionsComponent.disabledSwitch.gestioneAccumulatori = false;
              self.fruitionConditionsComponent.disabledSwitch.gestioneAccumulatori = self.readOnly;
            }
            self.fruitionConditionsComponent.messageInstanceObject = Object.assign({},self.messageInstanceObject);
          } */

        // if(self.customerTargetComponent && self.srvCampaign3.getStatusNumberFromCode(self.messageInstanceObject.status, self.statusMapping)>=self.statusMapping.customerTarget.number){
          if(self.customerTargetComponent){
            self.customerTargetComponent.messageInstanceObject = Object.assign({},self.messageInstanceObject);
            setTimeout(function(){
              self.customerTargetComponent.checkVincoliCustomerTarget();
            },100);
          }


          if(self.gestioneNuovaTouchpoint==true){
            if(+self.messageInstanceObject.id>0 && !self.touchpointLoaded){
              self.reloadTouchPoints();
              self.touchpointLoaded = true;
            }
          }

          if(self.productsTargetComponent){
            self.productsTargetComponent.messageInstanceObject = Object.assign({},self.messageInstanceObject);
          }

          if(self.touchpointComponent){
            self.touchpointComponent.messageInstanceObject = Object.assign({},self.messageInstanceObject);
          }

          if(self.validationsComponent){
            self.validationsComponent.messageInstanceObject = Object.assign({},self.messageInstanceObject);
            self.validationsComponent.reloadData();
            self.validationsComponent.setStatusDescription();
          }


       },100);

    }
  }
  }
  ngOnInit() {


    this.touchpointLoaded = this.gestioneNuovaTouchpoint==true? false : true;

    //this.currentJsonSchemaMode = this.srvCampaign3.schema_modes.CREATE;
    this.language = this.authService.sessionHelper.selectedLanguage;
    this.dateFormat = this.srvCalendar["calendars"][this.authService.sessionHelper.selectedLanguage].dateFormatFilter;

    this.campaign3MessageInstanceRules = new Campaign3MessageInstanceRules();

    this.initAll();
  }
  breadcrumbClicked(breadcrumb:BreadCrumbModel) {
    if (breadcrumb.routerLink) {
      this.router.navigate([breadcrumb.routerLink]);
    } else {
      console.log("nessuna route implementata");
    }
  }
  phaseClicked(phase: PhaseToolbarModel) {
    //è stato fatto click su un pallino della fase, vai a quella fase, solo se è completa e diversa da quella corrente
    if (phase.done == true || phase.firstUndone == true) {
      this.goToPhase(phase.index);
    }
  }
  onValidationEditClicked(phaseIndex: number){
    let phase = this.campaignPhases.find(x=>x.index == phaseIndex)
    if(phase){
      this.phaseClicked(phase);
    }
  }
  initAll(){


    this.actionTypeCode = this.srvCampaign3.actionTypes.MESSAGE.shortCode;


    const TRANSLATIONS = this.srvTranslate.get(['companyApplications.applicationName','companyApplications.app_icon','companyApplications.msBaseUrl','common.back',
    'couponValidity.dayOfGeneration','couponValidity.fixedDate','couponValidity.dayOfGenerationOffset','couponValidity.lastDayOfMonthGeneration','couponValidity.firstDayOfMonthFollowingGeneration','couponValidity.lastDayOfMonthFollowingGeneration','couponValidity.dayofWeekFollowingGeneration','couponValidity.validityStartDay','couponValidity.validityStartDayOffset','couponValidity.lastDayOfMonthValidity','couponValidity.firstDayOfFollowingMonthValidity','couponValidity.lastDayOfFollowingMonthValidity','couponValidity.dayOfWeekFollowingValidity'
    ]);

    const INFO_CAMPAIGN = this.srvCampaign3.getCampaign(this.idCampaign);

    const MI_COMPLETE = this.messageInstanceId > 0 ? this.srvCampaign3.getMessageInstanceComplete(this.messageInstanceId) : Observable.of(null);

    const STATUS_LIST = this.srvCampaign3.getAllActionStatus();


    const ACTION_TYPES = this.srvCampaign3.getActionTypeList();
    //cambiata con quella corretta dei messaggi
    const MESSAGETYPES = this.srvCampaign3.getMessageTypes();
    const ADVANTAGETYPES =  this.srvCampaign3.getAdvantageTypes();
    const CAMPAIGN_LIST = this.srvCampaign3.getCampaignList();
     const MODALITA_INIZIO_FRUIZIONE = this.srvParam.list(null,null,[{key: "param_group", value: "validity_coupon"},{key: "param_code", value: "start"}]);
     const MODALITA_FINE_FRUIZIONE = this.srvParam.list(null,null,[{key: "param_group", value: "validity_coupon"},{key: "param_code", value: "end"}]);

    /*  const LISTA_ACCUMULATORI = this.srvLoyaltyAcm.getAllAcm(); */
    //rimossi i bruciati
        const LISTA_ACCUMULATORI = this.srvLoyaltyAcm.getAllAcmNoBurned();

     const MI_ROULE_TYPES = this.srvCampaign3.getMessageInstanceRuleTypes();
     const MI_OBJECT_TYPES = this.srvCampaign3.getMessageInstanceObjectTypes();

     const LISTA_DISTRIBUZIONE_CLUSTER = this.srvCampaign3.getDistributionListCluster();

     const LISTA_PANIERE = this.srvCampaign3.getBasketProductItems();
     const LISTA_DEPARTMENT = this.srvCampaign3.getProductDepartmentList();
     const LISTA_CATEGORIES = this.srvCampaign3.getAllProductCategories();

     const LISTA_AREE = this.srvCampaign3.getAreaGeoForCouponing();
     const LISTA_GRUPPI = this.srvCampaign3.getGroupsForCouponing();
     const LISTA_INSEGNE = this.srvCampaign3.getSalesNetworkForCouponing();
     const LISTA_NEGOZI = this.srvCampaign3.getStoresFromCampaigns({insegna: [],area: [],gruppo: "",codici: []});



     const LISTA_TOUCHPOINT_EMISSIONE =  (this.gestioneNuovaTouchpoint==true &&  +this.messageInstanceId>0) ? this.srvCampaign3.getTouchPointListForCouponing_new("E",this.actionTypeCode,this.messageInstanceId) :  ((this.gestioneNuovaTouchpoint==true &&  !this.messageInstanceId) ? Observable.of(null) : (!this.gestioneNuovaTouchpoint ? this.srvCampaign3.getTouchPointListForCouponing("E",this.actionTypeCode) : Observable.of(null)));


     const LISTA_TOUCHPOINT_FRUIZIONE =  (this.gestioneNuovaTouchpoint==true &&  +this.messageInstanceId>0) ? this.srvCampaign3.getTouchPointListForCouponing_new("F",this.actionTypeCode,this.messageInstanceId) :  ((this.gestioneNuovaTouchpoint==true &&  !this.messageInstanceId) ? Observable.of(null) : (!this.gestioneNuovaTouchpoint ? this.srvCampaign3.getTouchPointListForCouponing("F",this.actionTypeCode) : Observable.of(null)));


     const MIN_ID_ALLOWED_FOR_SAVING = this.paramsLoyService.getParamByKey('OLDEST.DUPLICABLE.ACTION')
     const LIST_FAV= this.srvCampaign3.getPreferredCoupons();
         const LISTA_ARTICOLI= this.srvCampaign3.getProductItemComplete();



     var self = this;

    Observable.zip(
      TRANSLATIONS,
      INFO_CAMPAIGN,
      MI_COMPLETE,
      STATUS_LIST,
      //COUPON_SCHEMA,
      ACTION_TYPES,MESSAGETYPES,ADVANTAGETYPES,CAMPAIGN_LIST,
      MODALITA_INIZIO_FRUIZIONE,MODALITA_FINE_FRUIZIONE,
      //LISTA_ARTICOLI,
      LISTA_ACCUMULATORI,
      MI_ROULE_TYPES,MI_OBJECT_TYPES,
      LISTA_DISTRIBUZIONE_CLUSTER,
      LISTA_PANIERE,LISTA_DEPARTMENT, LISTA_CATEGORIES,
      LISTA_AREE,LISTA_GRUPPI,LISTA_INSEGNE,LISTA_NEGOZI,LISTA_TOUCHPOINT_EMISSIONE,LISTA_TOUCHPOINT_FRUIZIONE,
      MIN_ID_ALLOWED_FOR_SAVING,LIST_FAV,LISTA_ARTICOLI
      ).subscribe(([
        res_trans,
        res_ic,
        res_mic,
        res_status,
        res_act_type,res_ct,res_adv_type,res_cl,
        res_mif, res_mff,
        res_acc,
        res_mi_rt,
        res_mi_ot,
        res_ldc,
        res_pan,res_dep,res_cat,
        res_aree,res_groups,res_insegne,res_stores,res_tp_e, res_tp_f,
        res_min_sav_id,res_list_fav,res_art
      ]) => {

      if(res_trans){
        self.translations = res_trans;
        self.translations["genericActionError"] = "Errore durante il salvataggio dell'Azione";
      }
      else{self.errorRetriveData=true;}

      if (res_ic && res_ic.length == 1) {
        self.campaignInfo = new Campaign3Info();
        self.campaignInfo.id = res_ic[0].id;
        self.campaignInfo.name = res_ic[0].name;
        self.campaignInfo.description = res_ic[0].description;
        self.campaignInfo.dateStart = this.srvCampaign3.getDateFromDateStringDB(res_ic[0].start_date)
        self.campaignInfo.dateEnd = this.srvCampaign3.getDateFromDateStringDB(res_ic[0].end_date);
      }
      else{self.errorRetriveData=true;}

      if(res_act_type && res_act_type.length>0){self.actionTypesList=res_act_type;}
      else{self.errorRetriveData=true;}

      //TODO cambiare questa chiamata perchè esiste già la corretta
      if(res_ct && res_ct.length>0){

        //ora passo correttamente la lista di messaggi non quella dei coupon getMessageTypes(campaign3service)
        self.combos.infobase.allMessageTypes = Object.assign([],res_ct);

        self.combos.infobase.messageTypes= self.combos.infobase.allMessageTypes.filter(x=>x.action_type_code == (self.actionTypeCode == this.srvCampaign3.actionTypes.COUPON.shortCode ? this.srvCampaign3.actionTypes.COUPON.code: (self.actionTypeCode == this.srvCampaign3.actionTypes.MESSAGE.shortCode ? this.srvCampaign3.actionTypes.MESSAGE.code : "")));
        console.log(self.combos.infobase.messageTypes);

      }

      else{self.errorRetriveData=true;}

      if(res_adv_type && res_adv_type.length>0){self.combos.infobase.advantageTypes=res_adv_type;}
      else{self.errorRetriveData=true;}

      if(res_mi_rt && res_mi_rt.length>0){self.miRuleTypesList=res_mi_rt;}
      else{self.errorRetriveData=true;}

      if(res_mi_ot && res_mi_ot.length>0){self.miObjectTypesList=res_mi_ot;}
      else{self.errorRetriveData=true;}

      if(res_ldc && res_ldc.length>0){self.distributionListEmission=res_ldc;
       /*  self.distributionListFruition=res_ldc */}
      else{self.errorRetriveData=true;}

      if(res_aree && res_aree.length>0){self.areeList=res_aree;}
      else{self.errorRetriveData=true;}

      if(res_groups && res_groups.length>0){self.groupList=res_groups;}
      else{self.errorRetriveData=true;}

      if(res_insegne && res_insegne.length>0){self.insegneList=res_insegne;}
      else{self.errorRetriveData=true;}

      if(res_stores && res_stores.length>0){self.storeList=res_stores;}
      else{self.errorRetriveData=true;}

      if(res_status && res_status.length>0){self.statusList=res_status;}
      else{self.errorRetriveData=true;}

      if(self.gestioneNuovaTouchpoint == true){
        if(+self.messageInstanceId>0){
          if(res_tp_e && res_tp_e.length>0){self.touchpointListEmission=res_tp_e;}
        /*   if(res_tp_f && res_tp_f.length>0){self.touchpointListFruition=res_tp_f;} */
          self.touchpointLoaded = true;
        }
        else{
          self.touchpointListEmission = [];
    /*       self.touchpointListFruition = []; */
        }
        self.show.touchpointComponent = true;
      }
      else{
        if(res_tp_e && res_tp_e.length>0){self.touchpointListEmission=res_tp_e;}
   /*      if(res_tp_f && res_tp_f.length>0){self.touchpointListFruition=res_tp_f;} */
        self.touchpointLoaded = true;
      }


      if(res_mif && res_mif.data && res_mif.data.length>0){
        self.combos.planning.modalitaInizioFruizione = [];
        for(let param of res_mif.data){
          let dropdown: GenerazioneDropdown = new GenerazioneDropdown();
          dropdown.id = param.id;
          dropdown.code = param.param_key;
          dropdown.description = self.translations["couponValidity."+param.description];
          self.combos.planning.modalitaInizioFruizione.push(dropdown);
        }
      }
      else{self.errorRetriveData=true;}

      if(res_mff && res_mff.data && res_mff.data.length>0){
        self.combos.planning.modalitaFineFruizione = [];
        for(let param of res_mff.data){
          let dropdown: GenerazioneDropdown = new GenerazioneDropdown();
          dropdown.id = param.id;
          dropdown.code = param.param_key;
          dropdown.description = self.translations["couponValidity."+param.description];
          self.combos.planning.modalitaFineFruizione.push(dropdown);
        }
      }
      else{self.errorRetriveData=true;}

      if(res_acc && res_acc.length>0){
        self.accumulatorListEmission = Object.assign([],res_acc);
        self.accumulatorListFruition =  Object.assign([],res_acc);
        self.filterAccumulatorsEmissionOnlyActive();
        self.filterAccumulatorsFruitionOnlyActive();
      }
      else{self.errorRetriveData=true;}

      if(res_pan && res_pan.length>0){
        self.paniereListEmission = Object.assign([],res_pan);
      /*   self.paniereListFruition =  Object.assign([],res_pan); */
      }
      else{self.errorRetriveData=true;}

      if(res_dep && res_dep.length>0){
        self.departmentListEmission = Object.assign([],res_dep);
      /*   self.departmentListFruition = Object.assign([],res_dep); */
      }
      else{self.errorRetriveData=true;}

      if(res_cat && res_cat.length>0){
        self.categoriesListEmission = Object.assign([],res_cat);
     /*    self.categoriesListFruition = Object.assign([],res_cat); */
      }
      else{self.errorRetriveData=true;}
           
        if (res_art && Array.isArray(res_art.data) && res_art.data.length > 0){
           
        self.listProductsEmission = Object.assign([], res_art.data);
      } else {
        self.errorRetriveData = true;
      }

     //inizializzazione componente fasi
     /*
      self.campaignPhases = self.srvCampaign3.getAllCampaignPhases();
      self.show.phases = true;
       */

      //inizializzazione componente breadcrumb
      self.breadcrumbs = self.srvCampaign3.getInitialBreadCrumbs_Message(self.campaignInfo.name);
      self.show.breadcrumbs = true;

      self.setMessageInstance(res_mic, res_min_sav_id, res_list_fav);

    });
        // Rileva esplicitamente le modifiche dopo aver aggiornato campaignInfo
        this.cdRef.detectChanges();
  }
  setFavourites(res_min_sav_id:any, res_list_fav:any){

    //Attivazione salvataggio a preferiti
    if (res_min_sav_id) {
      this.minIdToAllowSaving = res_min_sav_id.param_code;
      console.log("minIdToAllowSaving", this.minIdToAllowSaving);
      console.log(this.messageInstanceObject);
      if (this.messageInstanceObject && this.messageInstanceObject.id) {
        if ([this.statusMapping.inGenerazione.code, this.statusMapping.richiestaPubblicazione.code, this.statusMapping.pubblicazioneInInvio.code, this.statusMapping.pubblicata.code, this.statusMapping.pubblicazioneAnnullata.code].indexOf(this.messageInstanceObject.status) !== -1) {
          this.allowSaveActionTemplate = true;
        }
      }
    }

    if (res_list_fav) {
      // Trova l'entità corrispondente nell'array
      const foundEntity = res_list_fav.find(item => item.id === this.messageInstanceObject.id);

      if (foundEntity) {
          this.favouriteMessageInstance = res_list_fav;
          console.log("Entità trovata:", foundEntity);
          this.favouriteAction= true;

      } else {
          console.log("Nessuna entità trovata per l'ID specificato.");
      }
    }


  }
  filterAccumulatorsEmissionOnlyActive() {
    // Filtra gli oggetti in base alle date dateStart e dateEnd della campagna
    this.accumulatorListEmission = this.accumulatorListEmission.filter(acc => {
        // Confronta le date
        return (acc.state != 1 && acc.state!="1");
    });
  }
  filterAccumulatorsFruitionOnlyActive() {
    // Filtra gli oggetti in base alle date dateStart e dateEnd della campagna
    this.accumulatorListFruition = this.accumulatorListFruition.filter(acc => {
          // Confronta le date
          return (acc.state != 1 && acc.state!="1");
    });
  }
  filterAccumulatorsEmissionDateCampaign(startDate, endDate) {
    // Filtra gli oggetti in base alle date dateStart e dateEnd della campagna
    this.accumulatorListEmission = this.accumulatorListEmission.filter(acc => {
        // Converte le stringhe di data in oggetti Date per confrontarle
        const accStartDate = new Date(acc.dateStart);
        const accEndDate = new Date(acc.dateEnd);

        // Confronta le date
        return accStartDate >= startDate && accEndDate <= endDate;
    });
  }
  filterAccumulatorsFruitionDateCampaign(startDate, endDate) {
    // Filtra gli oggetti in base alle date dateStart e dateEnd della campagna
    this.accumulatorListFruition = this.accumulatorListFruition.filter(acc => {
        // Converte le stringhe di data in oggetti Date per confrontarle
        const accStartDate = new Date(acc.dateStart);
        const accEndDate = new Date(acc.dateEnd);

        // Confronta le date
        return accStartDate >= startDate && accEndDate <= endDate;
    });
  }
  onClickBackBtn() {
    //clicco su Indietro e diminuisco di uno la fase corrente, cioè torno alla fase precedente
    if (this.currentPhaseIndex > 0) {
      this.goToPhase(this.currentPhaseIndex - 1);
    }

  }
  hideAllForms() {
    this.show.infoBase = false;
    this.show.planning = false;
    this.show.actionType = false;
    this.show.emissionConditions = false;
    this.show.fruitionConditions = false;
    this.show.customerTarget = false;
    this.show.productsTarget = false;
    this.show.touchpoint = false;
    this.show.validations = false;
  }
  onClickConfirmBtn() {
    if(this.actionTypeCode == this.srvCampaign3.actionTypes.MESSAGE.shortCode){
      this.validaForms();
    }
    else{
      this.srvMessage.add({
        severity: 'error',
        summary: this.srvTranslate.instant('common.error'),
        detail: this.srvTranslate.instant('campaign.not_permitted') // Localizza questo messaggio
    });
        }
  }
  goToNextPhase() {
    const nextPhaseIndex = this.currentPhaseIndex + 1;
    if (nextPhaseIndex < this.campaignPhases.length) {
      this.goToPhase(nextPhaseIndex);
    }
  }
  goToPhase(index: number) {
    // Nascondi tutti i form e attiva il form corrispondente alla nuova fase
    this.hideAllForms();
    var self = this;
    setTimeout(function(){
      if (index >= 0 && index < self.campaignPhases.length) {
        self.showFormForPhase(index);
      }
    },100);
  }

  //old ShowFormPhase
 /*  showFormForPhase(index: number) {

    // Mostra il form corrispondente alla fase specificata
    switch (index) {
      case 0:
        this.show.infoBase = true;
        if(this.validationsComponent){
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;
      case 1:
        this.show.planning = true;
        if(this.validationsComponent){
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;
      case 2:
        this.show.actionType = true;
        if(this.validationsComponent){
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;
      case 3:
       this.show.emissionConditions = true
       if(this.validationsComponent){
        this.validationsComponent.enableCheckStatusContinuous(false);
      }
        break;
      case 4:
       this.show.fruitionConditions = true
       if(this.validationsComponent){
        this.validationsComponent.enableCheckStatusContinuous(false);
      }
        break;
      case 5:
        this.show.customerTarget = true
        if(this.validationsComponent){
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
          break;
      case 6:
        this.show.productsTarget = true
        if(this.validationsComponent){
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
          break;
      case 7:
        this.show.touchpoint = true;
        if(this.validationsComponent){
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
          break;
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
      case 14:
      case 15:
      case 16:
      case 17:
      case 18:

        this.show.validations = true;
        var self = this;
        setTimeout(function(){
          self.validationsComponent.enableCheckStatusContinuous(true);
        })
          break;
      default:
        console.log("Nessun componente per la Fase: "+index);
        if(this.validationsComponent){
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;

      // Aggiungo altri casi per le fasi successive...
    }

    // Aggiorna l'indicatore della fase corrente
    this.campaignPhases[this.currentPhaseIndex].current = false;
    this.campaignPhases[index].current = true;
    this.currentPhaseIndex = index;
  } */
  showFormForPhase(index: number) {
    // Mostra il form corrispondente alla fase specificata
    switch (index) {
      case 0:
        this.show.infoBase = true;
        if (this.validationsComponent) {
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;
      case 1:
        this.show.planning = true;
        if (this.validationsComponent) {
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;
      case 2:
        this.show.actionType = true;
        if (this.validationsComponent) {
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;
      case 3:
        this.show.emissionConditions = true;
        if (this.validationsComponent) {
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;
      case 4:
        this.show.customerTarget = true;
        if (this.validationsComponent) {
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;
      case 5:
        this.show.productsTarget = true;
        if (this.validationsComponent) {
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;
      case 6:
        this.show.touchpoint = true;
        if (this.validationsComponent) {
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
      case 14:
      case 15:
      case 16:
      case 17:
      case 18:
        this.show.validations = true;
        var self = this;
        setTimeout(function () {
          self.validationsComponent.enableCheckStatusContinuous(true);
        });
        break;
      default:
        console.log("Nessun componente per la Fase: " + index);
        if (this.validationsComponent) {
          this.validationsComponent.enableCheckStatusContinuous(false);
        }
        break;

      // Aggiungo altri casi per le fasi successive...
    }

    // Aggiorna l'indicatore della fase corrente
    this.campaignPhases[this.currentPhaseIndex].current = false;
    this.campaignPhases[index].current = true;
    this.currentPhaseIndex = index;
  }

  onConfirmButtonEnabled(enabled: boolean) {
    this.enable.confirmButton = enabled;
  }
  setMessageInstance(res_mic: any,res_min_sav_id:any, res_list_fav:any){

    if (res_mic && res_mic.messageInstance && res_mic.messageInstance.length == 1) {

      this.schemaMode = this.getSchemaMode(res_mic.messageInstance[0].status);

      this.setMessageInstanceInfo(res_mic,res_min_sav_id, res_list_fav);

      this.show.globalFormsSchema = true;
    /*
      this.srvCampaign3.getJsonFormSchema(this.actionTypeCode,this.schemaMode,res_mic.messageInstance[0].messageId).subscribe(resSchema => {

         if (resSchema && resSchema.length==1) {
            //this.globalFormsSchema = this.srvCampaign3.getPreparedFormSchemas(resSchema[0]);
            this.setMessageInstanceInfo(res_mic,res_min_sav_id, res_list_fav);

            this.show.globalFormsSchema = true;
         }
         else {
           //caso non viene restituito schema, devi fermarti (da gestire)!
           this.globalFormsSchema = null;
           this.srvMessage.add({ severity: 'error', summary: 'Error', detail: "No template schema!" });
         }

       });
        */


      /*
      * IMPORTANTE: lo status nella message instance è l'id della prima fase non completa!
      * Cioè se ho status = 2 vuol dire che la fase 2 cioè Pianificazione è la prima fase non completa.
      */

    }
    else{
      this.actionTypeCode = this.srvCampaign3.actionTypes.MESSAGE.shortCode;
      this.campaignPhases = this.srvCampaign3.getAllCampaignPhases(this.srvCampaign3.actionTypes.MESSAGE.code);
      this.show.phases = true;
      this.globalFormsSchema = null;
      this.show.globalFormsSchema = true;
      this.messageInstanceObject = new MessageInstanceObject();
      this.messageInstanceObject.campaignId = this.idCampaign;
      this.messageInstanceObject.status = this.statusMapping.infoBase.code; //prima fase
      this.campaignTypeName = "";
      this.campaignTypeDescription = "";
      //controllo in quale fase ci troviamo, cioè qual è la prima che non è stata completata
      var self = this;
      setTimeout(function(){
        self.processPhases(0,true); //perchè considero l'index
        self.goToPhase(0); //-1 perchè considero l'index
      },100);

    }
  }
  onFormSchemaChanged(newGlobalFormSchema: JsonSchema){
    this.globalFormsSchema = newGlobalFormSchema;
    var self = this;

    if(this.infoBaseComponent){
        this.infoBaseComponent.ready.form = false;
        this.infoBaseComponent.formSchema = newGlobalFormSchema.properties.infoBase;
        setTimeout(function(){
          self.infoBaseComponent.ready.form = true;
        },100);
    }


    if(this.planningComponent){
      this.planningComponent.show.form = false;
      this.planningComponent.formSchema = newGlobalFormSchema.properties.pianificazione;
      setTimeout(function(){
        self.planningComponent.show.form = true;
        setTimeout(function(){
          self.planningComponent.ngOnInit();
        },100);
      },100);
    }

    if(this.actionTypeComponent){
      this.actionTypeComponent.show.form = false;
      this.actionTypeComponent.formSchema = newGlobalFormSchema.properties.tipoAzioni;
      setTimeout(function(){
        self.actionTypeComponent.show.form = true;
        setTimeout(function(){
          self.actionTypeComponent.ngOnInit();
        },100);
      },100);

    }
    if(this.emissionConditionsComponent){
      this.emissionConditionsComponent.show.form = false;
      this.emissionConditionsComponent.formSchema = newGlobalFormSchema.properties.emissione;
      setTimeout(function(){
        self.emissionConditionsComponent.show.form = true;
        setTimeout(function(){
          self.emissionConditionsComponent.ngOnInit();
        },100);
      },100);

      //self.emissionConditionsComponent.loadEmissionModel();
    }
    /* if(this.fruitionConditionsComponent){
      this.fruitionConditionsComponent.show.form = false;
      this.fruitionConditionsComponent.formSchema = newGlobalFormSchema.properties.fruizione;
      setTimeout(function(){
        self.fruitionConditionsComponent.show.form = true;
        setTimeout(function(){
          self.fruitionConditionsComponent.ngOnInit();
        },100);
      },100);
    } */
    if(this.customerTargetComponent){
      this.customerTargetComponent.schemaMode = newGlobalFormSchema.mode;
      this.customerTargetComponent.formSchema = newGlobalFormSchema.properties.customerTarget;
      this.customerTargetComponent.show.form = false;
      setTimeout(function(){
        self.customerTargetComponent.show.form = true;
        setTimeout(function(){
          self.customerTargetComponent.ngOnInit();
        },100);
      },100);
    }
    if(this.productsTargetComponent){
      this.productsTargetComponent.show.form = false;
      this.productsTargetComponent.formSchema = newGlobalFormSchema.properties.targetArticoli;
      setTimeout(function(){
        self.productsTargetComponent.show.form = true;
        setTimeout(function(){
          self.productsTargetComponent.ngOnInit();
        },100)
      },100);
    }
    if(this.touchpointComponent){
      this.touchpointComponent.show.form = false;
      this.touchpointComponent.formSchema = newGlobalFormSchema.properties.touchpoint;
      setTimeout(function(){
        self.touchpointComponent.show.form = true;
        setTimeout(function(){
          self.touchpointComponent.ngOnInit();
        },100);
      },100);
    }

}
  setMessageInstanceAllComponents(){
    if(this.infoBaseComponent)
      this.infoBaseComponent.messageInstanceObject = this.messageInstanceObject;
    if(this.planningComponent)
      this.planningComponent.messageInstanceObject = this.messageInstanceObject;
    if(this.actionTypeComponent)
      this.actionTypeComponent.messageInstanceObject = this.messageInstanceObject;
    if(this.emissionConditionsComponent)
      this.emissionConditionsComponent.messageInstanceObject = this.messageInstanceObject;
 /*    if(this.fruitionConditionsComponent)
      this.fruitionConditionsComponent.messageInstanceObject = this.messageInstanceObject; */
    if(this.customerTargetComponent)
      this.customerTargetComponent.messageInstanceObject = this.messageInstanceObject;
    if(this.productsTargetComponent)
      this.productsTargetComponent.messageInstanceObject = this.messageInstanceObject;
    if(this.touchpointComponent)
      this.touchpointComponent.messageInstanceObject = this.messageInstanceObject;
    if(this.validationsComponent)
      this.validationsComponent.messageInstanceObject = this.messageInstanceObject;

  }
  //TODO se chiedono di cambiare la create CREATE con EDIT PREVIEW
  getSchemaMode(statusCode: string): string{
    let resMode = null;
    if(statusCode){

      if(
        statusCode == this.statusMapping.infoBase.code ||
        statusCode == this.statusMapping.planning.code ||
        statusCode == this.statusMapping.actionTypes.code ||
        statusCode == this.statusMapping.emissionConditions.code ||
     /*    statusCode == this.statusMapping.fruitionConditions.code || */
        statusCode == this.statusMapping.customerTarget.code ||
        statusCode == this.statusMapping.productsTarget.code ||
        statusCode == this.statusMapping.touchpoints.code ||
        statusCode == this.statusMapping.validations.code ||
        statusCode == this.statusMapping.completaPreview.code
      ){
        resMode = this.srvCampaign3.schema_modes.CREATE;
      }
      else if(
        statusCode == this.statusMapping.generataInPreview.code ||
        statusCode == this.statusMapping.generazioneInErrore.code ||
        statusCode == this.statusMapping.pubblicazioneRifiutata.code
      ){
        resMode = this.srvCampaign3.schema_modes.EDIT_PREVIEW;
      }
      else if(statusCode == this.statusMapping.pubblicata.code){
        resMode = this.srvCampaign3.schema_modes.EDIT_DEFINITIVE;
      }
      else {
        //quì è giusto per tornare, ma se non si conosce lo stato allora sarà readonly=true
        this.readOnly = true;
        resMode = this.srvCampaign3.schema_modes.CREATE;
      }
    }
    return resMode;
  }
  setMessageInstanceInfo(res_mic: any,res_min_sav_id:any, res_list_fav:any){
      //se è annullato, non puoi più modificare nulla dei valori, devi rifare la promo
      if(
        res_mic.messageInstance[0].status == this.statusMapping.pubblicazioneAnnullata.code ||
        res_mic.messageInstance[0].status == this.statusMapping.pubblicazioneInInvio.code ||
        res_mic.messageInstance[0].status == this.statusMapping.richiestaPubblicazione.code ||
        res_mic.messageInstance[0].status == this.statusMapping.inGenerazione.code
      ){
        this.readOnly = true;
      }
      else{
      this.readOnly = false;
    }
      //se lo stato e successivo a validazioni, allora non consentire il bottone conferma
      if(this.srvCampaign3.getStatusNumberFromCode(res_mic.messageInstance[0].status,this.statusMapping)> this.statusMapping.completaPreview.number) this.enable.confirmButton = false;

      this.uiModes.infoBase = this.srvCampaign3.getStatusNumberFromCode(res_mic.messageInstance[0].status,this.statusMapping)>1 ? this.srvCampaign3.ui_modes.EDIT : this.srvCampaign3.ui_modes.CREATE;
      this.uiModes.planning = this.srvCampaign3.getStatusNumberFromCode(res_mic.messageInstance[0].status,this.statusMapping)>2 ? this.srvCampaign3.ui_modes.EDIT : this.srvCampaign3.ui_modes.CREATE;
      this.uiModes.actionTypes = this.srvCampaign3.getStatusNumberFromCode(res_mic.messageInstance[0].status,this.statusMapping)>3 ? this.srvCampaign3.ui_modes.EDIT : this.srvCampaign3.ui_modes.CREATE;
      this.uiModes.emissionConditions = this.srvCampaign3.getStatusNumberFromCode(res_mic.messageInstance[0].status,this.statusMapping)>4 ? this.srvCampaign3.ui_modes.EDIT : this.srvCampaign3.ui_modes.CREATE;
     // this.uiModes.fruitionConditions = this.srvCampaign3.getStatusNumberFromCode(res_mic.messageInstance[0].status,this.statusMapping)>5 ? this.srvCampaign3.ui_modes.EDIT : this.srvCampaign3.ui_modes.CREATE;
      this.uiModes.customerTarget = this.srvCampaign3.getStatusNumberFromCode(res_mic.messageInstance[0].status,this.statusMapping)>5 ? this.srvCampaign3.ui_modes.EDIT : this.srvCampaign3.ui_modes.CREATE;
      this.uiModes.productsTarget = this.srvCampaign3.getStatusNumberFromCode(res_mic.messageInstance[0].status,this.statusMapping)>6 ? this.srvCampaign3.ui_modes.EDIT : this.srvCampaign3.ui_modes.CREATE;
      this.uiModes.touchpoint = this.srvCampaign3.getStatusNumberFromCode(res_mic.messageInstance[0].status,this.statusMapping)>7 ? this.srvCampaign3.ui_modes.EDIT : this.srvCampaign3.ui_modes.CREATE;

      let statusIndex = this.srvCampaign3.getStatusNumberFromCode(res_mic.messageInstance[0].status,this.statusMapping)-1 < 7 ? this.srvCampaign3.getStatusNumberFromCode(res_mic.messageInstance[0].status,this.statusMapping)-1 : 7;

/*

      if(this.messageInstanceObject){
        this.campaignPhases = this.srvCampaign3.getAllCampaignPhases("CPN");
        this.show.phases = true;
      }
      else{
        this.campaignPhases = this.srvCampaign3.getAllCampaignPhases("CPN");
        this.show.phases = true;
      }

  */
      this.messageInstanceObject = res_mic.messageInstance[0];

      let actionCode = this.actionTypeCode == this.srvCampaign3.actionTypes.COUPON.shortCode ? this.srvCampaign3.actionTypes.COUPON.code : (this.actionTypeCode == this.srvCampaign3.actionTypes.MESSAGE.shortCode ? this.srvCampaign3.actionTypes.MESSAGE.code : null);
      if(actionCode){
        this.campaignPhases = this.srvCampaign3.getAllCampaignPhases(actionCode);
        this.show.phases = true;
      }
      //inizializzazione componente breadcrumb
      this.breadcrumbs = this.srvCampaign3.getInitialBreadCrumbs_Message(this.campaignInfo.name);
      this.show.breadcrumbs = true;
      this.messageInstanceObject.status = this.messageInstanceObject.status ? this.messageInstanceObject.status : this.statusMapping.infoBase.code;
      this.breadcrumbs[2].description = this.messageInstanceObject.name;
      this.campaignTypeName = "Message";
      let ind = this.combos.infobase.messageTypes.findIndex(x => x.id == this.messageInstanceObject.messageId);
      this.campaignTypeDescription = ind>-1 ? this.combos.infobase.messageTypes[ind].description : "";
      this.isActionDynamic = this.messageInstanceObject.flgCouponingMethod === 'D';
      var self = this;
      
      this.setFavourites(res_min_sav_id, res_list_fav);

      setTimeout(function(){
        self.breadcrumbComponent.campaignTypeName = self.campaignTypeName;
        self.breadcrumbComponent.campaignTypeDescription = self.campaignTypeDescription;

        //controllo in quale fase ci troviamo, cioè qual è la prima che non è stata completata
        self.processPhases(statusIndex,true); //perchè considero l'index
        self.goToPhase(statusIndex); //-1 perchè considero l'index
        var self2=self;
        setTimeout(function(){
          self2.messageInstanceObjectChange(self2.messageInstanceObject); // scateno l'onchange della message instance per verificare dei controlli
        },100)
      },100);

  }
  anteprimaBarcodeChange(barcode: string){
    if(barcode){
      if(this.touchpointComponent){
        this.touchpointComponent.barcodeAnteprima = barcode;
        //this.touchpointComponent.checkAnteprimaEnabled();
      }
    }
  }
  async validaForms() {

    let maxIndexToPerformValidation = this.currentPhaseIndex < this.getFirstPhaseUndoneIndex() ? (this.getFirstPhaseUndoneIndex()-1) : this.getFirstPhaseUndoneIndex();

    let validationInfoBase = await this.infoBaseComponent.performValidationInfoBase();
    if(!validationInfoBase){
      this.goToPhase(0);
      return;
    }
    let validationPlanning = (maxIndexToPerformValidation >= 1 && this.planningComponent) ? await this.planningComponent.performValidationPlanning() : true;
    if(!validationPlanning){
      this.goToPhase(1);
      return;
    }

    let validationActionType = (maxIndexToPerformValidation >= 2 && this.actionTypeComponent) ? await this.actionTypeComponent.performValidationActionType() : true;
    if(!validationActionType){
      this.goToPhase(2);
      return;
    }

    let validationEmissionConditions = (maxIndexToPerformValidation >= 3 && this.emissionConditionsComponent) ? await this.emissionConditionsComponent.performValidationEmissionConditions() : true;
    if(!validationEmissionConditions){
      this.goToPhase(3);
      return;
    }

 /*    let validationFruitionConditions = (maxIndexToPerformValidation >= 4 && this.fruitionConditionsComponent) ? await this.fruitionConditionsComponent.performValidationFruitionConditions() : true;
    if(!validationFruitionConditions){
      this.goToPhase(4);
      return;
    } */


    //cambio tutti i gotophase da qui in poi

    let validationCustopmerTarget = (maxIndexToPerformValidation >= 4 && this.customerTargetComponent) ? await this.customerTargetComponent.performValidationCustomerTarget() : true;
    if(!validationCustopmerTarget){
    /*   this.goToPhase(5); */
    this.goToPhase(4);
      return;
    }

    let validationProductsTarget = (maxIndexToPerformValidation >= 5 && this.productsTargetComponent) ? await this.productsTargetComponent.performValidationProductsTarget() : true;
    if(!validationProductsTarget){
   /*    this.goToPhase(6); */
   this.goToPhase(5);
      return;
    }

    let validationTouchpoints = (maxIndexToPerformValidation >= 6 && this.touchpointComponent) ? await this.touchpointComponent.performValidationTouchpoint() : true;
    if(!validationTouchpoints){
      this.goToPhase(6);
     /*  this.goToPhase(7); */
      return;
    }
    //se tutto è giusto procedi al salvataggio
    this.saveMessageInstanceObject();

  }

  reloadMessageInstance(){
    var self = this;
    this.srvCampaign3.getMessageInstanceComplete(this.messageInstanceObject.id).subscribe(res=>{
      if(res && res.messageInstance.length==1){
        let mi = res.messageInstance[0];
        self.messageInstanceObject = mi;
        if(self.infoBaseComponent)
          self.infoBaseComponent.messageInstanceObject = mi;
        if(self.planningComponent)
          self.planningComponent.messageInstanceObject = mi;
        if(self.actionTypeComponent)
          self.actionTypeComponent.messageInstanceObject = mi;
        if(self.emissionConditionsComponent)
          self.emissionConditionsComponent.messageInstanceObject = mi;
     /*    if(self.fruitionConditionsComponent)
          self.fruitionConditionsComponent.messageInstanceObject = mi; */

        if(self.customerTargetComponent)
          self.customerTargetComponent.messageInstanceObject = mi;
        if(self.productsTargetComponent)
          self.productsTargetComponent.messageInstanceObject = mi;
        if(self.touchpointComponent)
          self.touchpointComponent.messageInstanceObject = mi;
        if(self.validationsComponent)
          self.productsTargetComponent.messageInstanceObject = mi;

          var self2 = self;
          setTimeout(function(){
            self2.messageInstanceObjectChange(res.messageInstance[0]);
          },100);

      }
    })
  }
  onReloadAfterUnpublish() {
    this.reloadMessageInstance();
  }
  onReloadAfterReset() {
    this.reloadMessageInstance();
  }

  saveMessageInstanceObject(){
      //valorizzo l'oggettone
      /*
        - ricalcolo il massimo index per fare la validazione.
        - se sono in una fase minore della prima non fatta lo status è lo stesso di quello corrente
        - se sono nella prima fase non fatta status è il prossimo
        */

      let maxIndexToPerformValidation = this.currentPhaseIndex < this.getFirstPhaseUndoneIndex() ? (this.getFirstPhaseUndoneIndex()-1) : this.getFirstPhaseUndoneIndex();


      let statusToSave = null;
      if(
        this.messageInstanceObject.status == this.statusMapping.infoBase.code ||
        this.messageInstanceObject.status == this.statusMapping.planning.code ||
        this.messageInstanceObject.status == this.statusMapping.actionTypes.code ||
        this.messageInstanceObject.status == this.statusMapping.emissionConditions.code ||
       /*  this.messageInstanceObject.status == this.statusMapping.fruitionConditions.code || */
        this.messageInstanceObject.status == this.statusMapping.customerTarget.code ||
        this.messageInstanceObject.status == this.statusMapping.productsTarget.code
      ){
        //da KS-5421 per ogni stato con promo non completa
        let nextStatusNumber = this.srvCampaign3.getStatusNumberFromCode(this.messageInstanceObject.status,this.statusMapping)+1;
        let firstundoneIndex= this.getFirstPhaseUndoneIndex();
        let statusFromNumber= this.srvCampaign3.getStatusCodeFromNumber(nextStatusNumber,this.statusMapping);


        statusToSave = maxIndexToPerformValidation < firstundoneIndex ? this.messageInstanceObject.status : statusFromNumber;
        this.messageInstanceObject.flgPreview = "9";


      }
      else if(
        this.messageInstanceObject.status == this.statusMapping.touchpoints.code ||
        this.messageInstanceObject.status == this.statusMapping.validations.code ||
        this.messageInstanceObject.status == this.statusMapping.completaPreview.code
      ){
        /*
         * se sono nei touchpoint allora sto per salvare l'ultimo stato e perciò il prossimo stato è quello delle validazioni.
         * questo vuol dire che la promo e completa e da qui in poi lo status varrà sempre 0 e quello che cambia è il flgDpl e flgPreview
         */

        statusToSave = this.statusMapping.completaPreview.statusToSave;
        this.messageInstanceObject.flgPreview = this.statusMapping.completaPreview.flgPreview;
        this.messageInstanceObject.flgDpl = this.statusMapping.completaPreview.flgDpl;
      }
      else if(this.messageInstanceObject.status == this.statusMapping.generataInPreview.code){
        //ancora editabile
        statusToSave = this.statusMapping.generataInPreview.statusToSave;
        this.messageInstanceObject.flgPreview = this.statusMapping.generataInPreview.flgPreview;
        this.messageInstanceObject.flgDpl = this.statusMapping.generataInPreview.flgDpl;
      }
      else if(this.messageInstanceObject.status == this.statusMapping.inGenerazione.code){
        //ancora editabile
        statusToSave = this.statusMapping.inGenerazione.statusToSave;
        this.messageInstanceObject.flgPreview = this.statusMapping.inGenerazione.flgPreview;
        this.messageInstanceObject.flgDpl = this.statusMapping.inGenerazione.flgDpl;
      }
      else if(this.messageInstanceObject.status == this.statusMapping.generazioneInErrore.code){
        //ancora editabile
        statusToSave = this.statusMapping.generazioneInErrore.statusToSave;
        this.messageInstanceObject.flgPreview = this.statusMapping.generazioneInErrore.flgPreview;
        this.messageInstanceObject.flgDpl = this.statusMapping.generazioneInErrore.flgDpl;
      }
      else if(this.messageInstanceObject.status == this.statusMapping.pubblicata.code){
        //ancora editabile
        statusToSave = this.statusMapping.pubblicata.statusToSave;
        this.messageInstanceObject.flgPreview = this.statusMapping.pubblicata.flgPreview;
        this.messageInstanceObject.flgDpl = this.statusMapping.pubblicata.flgDpl;
      }
      else{
        //quì non dovrebbe andarci non ci sono altri stati
        statusToSave = this.messageInstanceObject.status;
      }
      this.messageInstanceObject.campaignId = this.idCampaign;

      /*** INFO BASE ***/
      //this.actionTypesList.find(x => x.code == this.infoBaseComponent.actionType.currentCode)

      if(this.infoBaseComponent){
        console.log(this.infoBaseComponent.fieldModel.message_type.id);
        this.messageInstanceObject.messageId = this.infoBaseComponent.fieldModel.message_type.id;

        this.messageInstanceObject.description = this.infoBaseComponent.fieldModel.public_description;
        this.messageInstanceObject.notes = this.infoBaseComponent.fieldModel.int_note;
        this.messageInstanceObject.name = this.infoBaseComponent.fieldModel.name;
        this.messageInstanceObject.code = this.infoBaseComponent.fieldModel.int_code;
      }


      /*** PLANNING ***/
      if(this.planningComponent){
        this.messageInstanceObject.startEmissionDate = this.srvCampaign3.getDateStringDBFromDate(this.planningComponent.fieldModel.data_inizio_emissione);
        this.messageInstanceObject.endEmissionDate = this.srvCampaign3.getDateStringDBFromDate(this.planningComponent.fieldModel.data_fine_emissione);
      /*   this.messageInstanceObject.startFruitionDate = this.srvCampaign3.getDateStringDBFromDate(this.planningComponent.fieldModel.data_inizio_fruizione);
        this.messageInstanceObject.endFruitionDate = this.srvCampaign3.getDateStringDBFromDate(this.planningComponent.fieldModel.data_fine_fruizione);
        this.messageInstanceObject.couponValidityDateStart = this.srvCampaign3.getDateStringDBFromDate(this.planningComponent.fieldModel.data_inizio_fruizione_fissa);
        this.messageInstanceObject.couponValidityDateEnd = this.srvCampaign3.getDateStringDBFromDate(this.planningComponent.fieldModel.data_fine_fruizione_fissa); */
       /*  this.messageInstanceObject.couponValidityStartOffsetDay = this.planningComponent.fieldModel.offset_inizio_fruizione;
        this.messageInstanceObject.couponValidityEndOffsetDay = this.planningComponent.fieldModel.offset_fine_fruizione; */
        this.messageInstanceObject.couponValidityStartWeekDay = this.planningComponent.fieldModel.giorno_settimana_inizio ? this.planningComponent.fieldModel.giorno_settimana_inizio.value : null;
        this.messageInstanceObject.couponValidityEndWeekDay = this.planningComponent.fieldModel.giorno_settimana_fine ? this.planningComponent.fieldModel.giorno_settimana_fine.value : null;
       /*  this.messageInstanceObject.couponValidityDateStartMode = (this.planningComponent.fieldModel.modalita_inizio_fruizione && this.planningComponent.fieldModel.modalita_inizio_fruizione.code) ? this.planningComponent.fieldModel.modalita_inizio_fruizione.code : null;
        this.messageInstanceObject.couponValidityDateEndMode = (this.planningComponent.fieldModel.modalita_fine_fruizione && this.planningComponent.fieldModel.modalita_fine_fruizione.code) ? this.planningComponent.fieldModel.modalita_fine_fruizione.code : null; */
      }



      if(this.actionTypeComponent){
        this.messageInstanceObject.targetLoyaltyClass = this.actionTypeComponent.fieldModel.customerpromo;
        this.messageInstanceObject.flgCouponingMethod = (this.actionTypeComponent.fieldModel.generationCoupon == this.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.code ? this.srvCampaign3.tipoAzioneStaticoDinamico.STATIC.shortCode : (this.actionTypeComponent.fieldModel.generationCoupon == this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.code ? this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.shortCode : null));
          if (this.messageInstanceObject.flgCouponingMethod==this.srvCampaign3.tipoAzioneStaticoDinamico.DYNAMIC.shortCode ){
        this.isActionDynamic=true;
      }else{
        this.isActionDynamic=false;

      }
        this.messageInstanceObject.promoEmission = this.actionTypeComponent.fieldModel.promotype;
      }




      this.messageInstanceObject.messageInstanceRule = [];

      if(this.emissionConditionsComponent){
        this.emissionConditionsComponent.createRules();
        let defaultTotalCouponNumber=9999999;
        this.messageInstanceObject.totalCouponNumber = this.emissionConditionsComponent.maxEmissioniTotali ?  this.emissionConditionsComponent.maxEmissioniTotali.fieldModel : defaultTotalCouponNumber;

        this.buildMessageInstanceRulesObject_EmissionContitions();
        this.setMessageInstanceRuleObject_EmissionConditions();
      }



  /*     if(this.fruitionConditionsComponent){
        this.fruitionConditionsComponent.createRules();
        this.messageInstanceObject.couponUseNumber = this.fruitionConditionsComponent.fieldModel.utilizziCoupon.numero ? this.fruitionConditionsComponent.fieldModel.utilizziCoupon.numero : null;
        this.messageInstanceObject.couponUseType = this.fruitionConditionsComponent.fieldModel.utilizziCoupon.tipo ? this.fruitionConditionsComponent.fieldModel.utilizziCoupon.tipo.code : null;

        this.buildMessageInstanceRulesObject_FruitionContitions();
        this.setMessageInstanceRuleObject_FruitionConditions();
      } */

      //fruition condition non esiste ma per far andare in generazione devo valorizzare couponUseNumber e couponUseType
      //scelti come default 1 e singolo
      this.messageInstanceObject.couponUseNumber = 1;
      this.messageInstanceObject.couponUseType = 'S';


      if(this.customerTargetComponent){

        this.customerTargetComponent.createRules();
        this.messageInstanceObject.cardHolderType = (this.customerTargetComponent.fieldModel.tipoControllo && this.customerTargetComponent.fieldModel.tipoControllo.value) ? this.customerTargetComponent.fieldModel.tipoControllo.value : null;
        this.buildMessageInstanceRulesObject_CustomerTarget();
        this.setMessageInstanceRuleObject_CustomerTarget();
      }

      if(this.productsTargetComponent){

        this.productsTargetComponent.createRules();
        this.buildMessageInstanceRulesObject_ProductsTarget();
        this.setMessageInstanceRuleObject_ProductsTarget();
      }

       if(this.touchpointComponent){
        this.messageInstanceObject.layoutValue = this.touchpointComponent.fieldModel.layoutDefaultValue;
        this.touchpointComponent.createRules();
        this.buildMessageInstanceRulesObject_Touchpoints();
        this.setMessageInstanceRuleObject_Touchpoints();
       }
       this.messageInstanceObject.status = statusToSave;

      if(this.touchpointComponent.storesChanged == true){
        this.touchpointComponent.createStoreObjectsForTouchpoints("E","OFF");
        this.touchpointComponent.createStoreObjectsForTouchpoints("E","ON");
        this.messageInstanceObject.storeMessageOChannel = this.touchpointComponent.messageInstanceObject.storeMessageOChannel;
      }


      //Imposto le informazioni al breadcrumb
      if(this.breadcrumbComponent){
        this.breadcrumbComponent.campaignTypeName = this.actionTypesList.find(x => x.code == this.infoBaseComponent.actionType.currentCode).description;
        this.breadcrumbComponent.campaignTypeDescription = this.infoBaseComponent.fieldModel.message_type.description;
        this.breadcrumbComponent.arrayBreadcrumbs[this.breadcrumbComponent.arrayBreadcrumbs.length - 1].description = this.infoBaseComponent.fieldModel.name;
      }

      if(this.infoBaseComponent){{
        this.infoBaseComponent.show.new_or_exists = false;
      }

        
      this.messageInstanceObject.startFruitionDate = this.messageInstanceObject.startEmissionDate;
      this.messageInstanceObject.endFruitionDate = this.messageInstanceObject.endEmissionDate;
      this.performSaveMessageInstance(maxIndexToPerformValidation);
      
    }
  }
  /*
  getCouponFormSchema(schemaModes) {

    this.srvCampaign3.getJsonSchema(schemaModes).subscribe(resSchema => {
      if (resSchema) {

        this.globalFormsSchema = this.srvCampaign3.getPreparedFormSchemas(resSchema);
        //this.show.infoBase = true;
      }
      else {
        //caso non viene restituito schema, devi fermarti (da gestire)!
        alert('Non penso proprio!');
      }

    });
  }
  */
  processPhases(firstUndonePhaseIndex:number,isCurrent: boolean){
    /*
    verifica l'oggettone e stabilisce qual è la fase corrente
    si presuppone che le fasi precedenti sono complete
    */


    for(let phase of this.campaignPhases){
      if(phase.index<firstUndonePhaseIndex){
        phase.done = true;
        phase.current = false;
        phase.firstUndone = false;
      }
      else if(phase.index==firstUndonePhaseIndex){
        phase.done = false;
        phase.current = isCurrent ? isCurrent : false;
        phase.firstUndone = true;
      }
      else{
        phase.done = false;
        phase.current = false;
        phase.firstUndone = false;
      }
    }
  }
  performSaveMessageInstance(maxIndexToPerformValidation: number){

    var self = this;
    this.srvCampaign3.saveOrEditMessageInstanceComplete(this.messageInstanceObject).subscribe(res => {

      if (res) {
        if(res>0){
          self.uiModes.infoBase = this.srvCampaign3.ui_modes.EDIT;
          self.messageInstanceId = res;
          self.messageInstanceObject.id = res;
          self.getProductOnlyBarcodeReady= true;


          /*
          if(self.infoBaseComponent){
            self.infoBaseComponent.messageInstanceObject = self.messageInstanceObject;
          }
          if(self.planningComponent){
            self.planningComponent.messageInstanceObject = self.messageInstanceObject;
          }
          if(self.emissionConditionsComponent){
            self.emissionConditionsComponent.messageInstanceObject = self.messageInstanceObject;
          }
          if(self.fruitionConditionsComponent){
            self.fruitionConditionsComponent.messageInstanceObject = self.messageInstanceObject;
          }
          if(self.customerTargetComponent){
            self.customerTargetComponent.messageInstanceObject = self.messageInstanceObject;
          }
          if(self.productsTargetComponent){
            self.productsTargetComponent.messageInstanceObject = self.messageInstanceObject;
          }
          if(self.touchpointComponent){
            self.touchpointComponent.messageInstanceObject = self.messageInstanceObject;
          }
          if(self.validationsComponent){
            self.validationsComponent.messageInstanceObject = self.messageInstanceObject;
          }
            */
          self.reloadMessageInstance();

        }
        this.srvMessage.add({
          severity: 'success',
          summary: this.srvTranslate.instant('common.success'), // Usa la traduzione per "Success"
          detail: this.srvTranslate.instant('campaign.operation_successful') // Localizza questo messaggio
      });
              //salvataggio definitivo info base e disabilitazione combo tipo coupon (requisito)
        //self.messageInstanceObjectChange(self.messageInstanceObject);

        self.infoBaseComponent.message_type.disabled = true;

        if(maxIndexToPerformValidation==this.getFirstPhaseUndoneIndex()){

          self.processPhases(self.currentPhaseIndex+1,true);
        }
         //prendi da fasi
         if(maxIndexToPerformValidation == 6){
          this.touchpointComponent.ui_mode = this.srvCampaign3.ui_modes.EDIT;
          self.reloadTouchPoints();
         }


        let nextPhaseIndex= self.getFirstPhaseUndoneIndex();

        self.goToPhase(nextPhaseIndex);
      }
      else {
        self.srvMessage.add({
          severity: 'error',
          summary: this.srvTranslate.instant('common.error'),
          detail: this.srvTranslate.instant('campaign.generic_action_error') // Localizza questo messaggio
      });
            }
    });
  }
  onClickExitBtn(){
    this.router.navigate(['/campaign-list-3']);
  }
  buildMessageInstanceRulesObject_EmissionContitions(){
    this.campaign3MessageInstanceRules.CV_rules_emission = this.emissionConditionsComponent.CV_rules.length > 0 ? this.emissionConditionsComponent.CV_rules[0] : null;
    this.campaign3MessageInstanceRules.AC_rules_emission = this.emissionConditionsComponent.AC_rules.length > 0 ? this.emissionConditionsComponent.AC_rules[0] : null;
    this.campaign3MessageInstanceRules.BC_rules_emission = this.emissionConditionsComponent.BC_rules.length > 0 ? this.emissionConditionsComponent.BC_rules[0] : null;
    this.campaign3MessageInstanceRules.BA_rules_emission = this.emissionConditionsComponent.BA_rules.length > 0 ? this.emissionConditionsComponent.BA_rules[0] : null;
    this.campaign3MessageInstanceRules.LM_rules_emission = this.emissionConditionsComponent.LM_rules.length > 0 ? this.emissionConditionsComponent.LM_rules[0] : null;
  }
 /*  buildMessageInstanceRulesObject_FruitionContitions(){
    this.campaign3MessageInstanceRules.CV_rules_fruition = this.fruitionConditionsComponent.CV_rules.length > 0 ? this.fruitionConditionsComponent.CV_rules[0] : null;
    this.campaign3MessageInstanceRules.AC_rules_fruition = this.fruitionConditionsComponent.AC_rules.length > 0 ? this.fruitionConditionsComponent.AC_rules[0] : null;
    this.campaign3MessageInstanceRules.LM_rules_fruition = this.fruitionConditionsComponent.LM_rules.length > 0 ? this.fruitionConditionsComponent.LM_rules[0] : null;
  } */
  buildMessageInstanceRulesObject_CustomerTarget(){
    this.campaign3MessageInstanceRules.CT_rules_emission = this.customerTargetComponent.CT_rules_emission.length > 0 ? this.customerTargetComponent.CT_rules_emission[0] : null;
    this.campaign3MessageInstanceRules.CT_rules_fruition = this.customerTargetComponent.CT_rules_fruition.length > 0 ? this.customerTargetComponent.CT_rules_fruition[0] : null;
  }
  buildMessageInstanceRulesObject_ProductsTarget(){
    this.campaign3MessageInstanceRules.PT_rules_emission = this.productsTargetComponent.PT_rules_emission.length > 0 ? this.productsTargetComponent.PT_rules_emission[0] : null;
   /*  this.campaign3MessageInstanceRules.PT_rules_fruition = this.productsTargetComponent.PT_rules_fruition.length > 0 ? this.productsTargetComponent.PT_rules_fruition[0] : null; */
  }
  buildMessageInstanceRulesObject_Touchpoints(){
    this.campaign3MessageInstanceRules.OL_rules_emission = this.touchpointComponent.rules_OL_emission.length > 0 ? this.touchpointComponent.rules_OL_emission[0] : null;
    this.campaign3MessageInstanceRules.WZ_rules_emission = this.touchpointComponent.rules_WZ_emission.length > 0 ? this.touchpointComponent.rules_WZ_emission[0] : null;
    this.campaign3MessageInstanceRules.OL_rules_fruition = this.touchpointComponent.rules_OL_fruition.length > 0 ? this.touchpointComponent.rules_OL_fruition[0] : null;
    this.campaign3MessageInstanceRules.WZ_rules_fruition = this.touchpointComponent.rules_WZ_fruition.length > 0 ? this.touchpointComponent.rules_WZ_fruition[0] : null;
  
      
      // 🔹 Aggiungo tutte le regole RT create dal popup
    // 🔹 Aggiungo tutte le regole TR create dal popup
      var rtScopes = ['emission', 'fruition']; 
      for (var si = 0; si < rtScopes.length; si++) {
      var s = rtScopes[si];
      var rulesArrayName = s === 'emission' ? 'rules_TR_emission' : 'rules_TR_fruition';
      var key = s === 'emission' ? 'TR_rules_emission' : 'TR_rules_fruition';

      // Inizializzo sempre come array
      this.campaign3MessageInstanceRules[key] = [];

      var touchpointsList = this.touchpointComponent[rulesArrayName];
      if (!touchpointsList || touchpointsList.length === 0) continue;

      // Filtra solo le TR e aggiungile tutte
      var trRules = touchpointsList.filter(r => r && r.ruleType === 'TR');
      this.campaign3MessageInstanceRules[key].push(...trRules);
    }
  
    console.log('campaign3MessageInstanceRules popolato:', this.campaign3MessageInstanceRules);
  }
  setMessageInstanceRuleObject_EmissionConditions(){
    //emissione
    if(this.campaign3MessageInstanceRules.CV_rules_emission)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.CV_rules_emission);
    if(this.campaign3MessageInstanceRules.AC_rules_emission)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.AC_rules_emission);
    if(this.campaign3MessageInstanceRules.BC_rules_emission)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.BC_rules_emission);
    if(this.campaign3MessageInstanceRules.BA_rules_emission)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.BA_rules_emission);
    if(this.campaign3MessageInstanceRules.LM_rules_emission)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.LM_rules_emission);
  }
/*   setMessageInstanceRuleObject_FruitionConditions(){
    //fruizione
    if(this.campaign3MessageInstanceRules.CV_rules_fruition)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.CV_rules_fruition);
    if(this.campaign3MessageInstanceRules.AC_rules_fruition)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.AC_rules_fruition);
      if(this.campaign3MessageInstanceRules.LM_rules_fruition)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.LM_rules_fruition);
  } */
  setMessageInstanceRuleObject_CustomerTarget(){
    if(this.campaign3MessageInstanceRules.CT_rules_emission)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.CT_rules_emission);
    if(this.campaign3MessageInstanceRules.CT_rules_fruition)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.CT_rules_fruition);
  }
  setMessageInstanceRuleObject_ProductsTarget(){
    //fruizione
    if(this.campaign3MessageInstanceRules.PT_rules_emission)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.PT_rules_emission);
/*     if(this.campaign3MessageInstanceRules.PT_rules_fruition)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.PT_rules_fruition); */
  }
  setMessageInstanceRuleObject_Touchpoints(){
    //touchpoint
    if(this.campaign3MessageInstanceRules.OL_rules_emission)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.OL_rules_emission);
    if(this.campaign3MessageInstanceRules.OL_rules_fruition)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.OL_rules_fruition);
    if(this.campaign3MessageInstanceRules.WZ_rules_emission)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.WZ_rules_emission);
    if(this.campaign3MessageInstanceRules.WZ_rules_fruition)
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.WZ_rules_fruition);
    if (this.campaign3MessageInstanceRules.TR_rules_emission && this.campaign3MessageInstanceRules.TR_rules_emission.length > 0) {
      this.messageInstanceObject.messageInstanceRule.push(...this.campaign3MessageInstanceRules.TR_rules_emission);
    }
    if (this.campaign3MessageInstanceRules.TR_rules_fruition && this.campaign3MessageInstanceRules.TR_rules_fruition.length > 0) {
      this.messageInstanceObject.messageInstanceRule.push(...this.campaign3MessageInstanceRules.TR_rules_fruition);
    }
  }
  getFirstPhaseUndoneIndex():number{
    let index = null;

    for(let i=0; i<this.campaignPhases.length;i++){
     if(this.campaignPhases[i].firstUndone==true){
      index = i;
      return index;
     };
    }
    return index;
  }
  onRollingChanged(calculateFruitionDate: CalculateFruitionDateRequest){
      /*** viene da Planning ***/
      /*
      if(this.emissionConditionsComponent && this.srvCampaign3.getStatusNumberFromCode(this.messageInstanceObject.status,this.statusMapping)>=this.statusMapping.emissionConditions.number){
        this.emissionConditionsComponent.messageInstanceObject.couponValidityDateStart = calculateFruitionDate.coupon_validity_date_start;
        this.emissionConditionsComponent.messageInstanceObject.couponValidityDateEnd = calculateFruitionDate.coupon_validity_date_end
        this.emissionConditionsComponent.messageInstanceObject.couponValidityStartOffsetDay = calculateFruitionDate.coupon_validity_start_offset_day
        this.emissionConditionsComponent.messageInstanceObject.couponValidityEndOffsetDay = calculateFruitionDate.coupon_validity_end_offset_day;
        this.emissionConditionsComponent.messageInstanceObject.couponValidityStartWeekDay = calculateFruitionDate.coupon_validity_start_week_day;
        this.emissionConditionsComponent.messageInstanceObject.couponValidityEndWeekDay = calculateFruitionDate.coupon_validity_end_week_day;
        this.emissionConditionsComponent.messageInstanceObject.couponValidityDateStartMode = calculateFruitionDate.coupon_validity_date_start_mode
        this.emissionConditionsComponent.messageInstanceObject.couponValidityDateEndMode = calculateFruitionDate.coupon_validity_date_end_mode;
      }
      */
  }
  onSaveFavourite() {
      if (this.favouriteAction == false) {
          this.srvCampaign3.saveActionIntoFavourites(this.messageInstanceObject).subscribe(
              () => {
                  this.showSuccessPopup = true;
                  this.favouriteAction = true;
                  setTimeout(() => {
                      this.showSuccessPopup = false;
                  }, 3000);
                  console.log("Azione salvata nei preferiti con successo.");
              },
              () => {
                  console.log("Errore durante il salvataggio dell'azione nei preferiti.");
              }
          );
      } else {
          this.srvCampaign3.deleteActionFromFavourites(this.messageInstanceObject).subscribe(
              () => {
                  this.showSuccessDeletePopup = true;
                  this.favouriteAction = false;
                  setTimeout(() => {
                      this.showSuccessDeletePopup = false;
                  }, 3000);
                  console.log("Azione rimossa dai preferiti con successo.");
              },
              () => {
                  console.log("Errore durante la rimozione dell'azione dai preferiti.");
              }
          );
      }
  }
  onActionTypeChanged(code: string){
    //CPN o MSG
    if(code == this.srvCampaign3.actionTypes.COUPON.code){
      this.actionTypeCode = this.srvCampaign3.actionTypes.COUPON.shortCode;
    }
    else if(code == this.srvCampaign3.actionTypes.MESSAGE.code){
      this.actionTypeCode = this.srvCampaign3.actionTypes.MESSAGE.shortCode;
    }
    this.combos.infobase.couponTypes= this.combos.infobase.allMessageTypes.filter(x=>x.action_type_code == (this.actionTypeCode == this.srvCampaign3.actionTypes.COUPON.shortCode ? this.srvCampaign3.actionTypes.COUPON.code: (this.actionTypeCode == this.srvCampaign3.actionTypes.MESSAGE.shortCode ? this.srvCampaign3.actionTypes.MESSAGE.code : "")));

    var self = this;

    setTimeout(function(){
      if(self.infoBaseComponent){
        self.resetInfoBaseModel();
      }
    },100)

  }
  resetInfoBaseModel(){
    //reset dei model di infobase
    this.infoBaseComponent.fieldModel.public_description = null;
    this.infoBaseComponent.fieldModel.int_code = null;
    this.infoBaseComponent.fieldModel.int_note = null;
    this.infoBaseComponent.fieldModel.name = null;
    this.infoBaseComponent.show.formCoupon = false;
    this.show.actionType = false;
    this.infoBaseComponent.show.new_or_exists = true;
   // this.infoBaseComponent.show.actionType = false;


    var self = this;
    setTimeout(function(){
    //  self.infoBaseComponent.show.actionType = true;
    },100);
  }


  buildMessageInstanceRulesObject_Wizards() {
    this.campaign3MessageInstanceRules.WZ_rules_emission = this.validationsComponent.rules_WZ_emission.length > 0 ? this.validationsComponent.rules_WZ_emission[0] : null;
  }
  setMessageInstanceRuleObject_Wizard() {
    // Rimuovi le regole esistenti legate a WZ emission e fruition
    this.messageInstanceObject.messageInstanceRule = this.messageInstanceObject.messageInstanceRule.filter(
      el => !(el.ruleType === "WZ" && (el.ruleScope === "fruition" || el.ruleScope === "emission"))
    );

    // Aggiungi le nuove regole di emissione e fruition
    if (this.campaign3MessageInstanceRules.WZ_rules_emission) {
      this.messageInstanceObject.messageInstanceRule.push(this.campaign3MessageInstanceRules.WZ_rules_emission);
    }



  }

  saveSelectedWizard(){

    this.validationsComponent.createRules_Wizard();
    this.buildMessageInstanceRulesObject_Wizards();
    this.setMessageInstanceRuleObject_Wizard();
    this.performSaveMessageInstance(9);
    this.validationsComponent.disable.generaCouponPreview=true;

    
  }



  isActionDynamic: boolean = false;

onActionDynamicChanged(val: boolean) {
  this.isActionDynamic = val;
}



}



// WEBPACK FOOTER //
// ./src/app/views/campaing-3-message/campaign-3-message.component.ts